import { cookieWatchConfig, loggedInTimestampCookieConfig, loginStateCookieConfig } from './config';
import { readCookieValue } from './loginState';

export interface LoginStateChange {
  previousLoginStateRawValue: string | null;
  nextLoginStateRawValue: string | null;
  previousLoggedInTimestampRawValue: string | null;
  nextLoggedInTimestampRawValue: string | null;
}

export function watchLoginState(callback: (change: LoginStateChange) => void, intervalMs = cookieWatchConfig.pollIntervalMs) {
  let previousLoginStateRawValue = readCookieValue(loginStateCookieConfig.cookieName);
  let previousLoggedInTimestampRawValue = readCookieValue(loggedInTimestampCookieConfig.cookieName);

  const timer = window.setInterval(() => {
    const nextLoginStateRawValue = readCookieValue(loginStateCookieConfig.cookieName);
    const nextLoggedInTimestampRawValue = readCookieValue(loggedInTimestampCookieConfig.cookieName);

    if (nextLoginStateRawValue === previousLoginStateRawValue && nextLoggedInTimestampRawValue === previousLoggedInTimestampRawValue) {
      return;
    }

    callback({
      previousLoginStateRawValue,
      nextLoginStateRawValue,
      previousLoggedInTimestampRawValue,
      nextLoggedInTimestampRawValue,
    });
    previousLoginStateRawValue = nextLoginStateRawValue;
    previousLoggedInTimestampRawValue = nextLoggedInTimestampRawValue;
  }, intervalMs);

  return () => {
    window.clearInterval(timer);
  };
}
